import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.mariojarrinv.tech',
});

// Add a request interceptor to add the auth token
api.interceptors.request.use(async (config) => {
  try {
    // Get the user's email from localStorage
    const userEmail = localStorage.getItem('userEmail');
    
    // Only add authorization for admin routes
    if ((config.url.includes('/admin') || config.url.includes('/membership')) && userEmail === 'mariojarrunv@gmail.com') {
      config.headers.Authorization = `Bearer ${userEmail}`;
    }
    return config;
  } catch (error) {
    console.error('Error setting authorization header:', error);
    return config;
  }
});

// Add error handler interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    throw error.response?.data || error;
  }
);

export const protectedApi = {
  get: (url) => api.get(url),
  post: (url, data) => api.post(url, data),
  put: (url, data) => api.put(url, data),
  delete: (url) => api.delete(url),
  
  getProtectedData: () => api.get('/protected'),
  getAdminData: () => api.get('/api/v1/admin'),
  getProducts: (params = {}) => api.get('/api/v1/products', { params }),
  getProduct: (id) => api.get(`/api/v1/products/${id}`),
  getProductBySlug: (slug) => api.get(`/api/v1/products/slug/${slug}`),
  createProduct: (data) => api.post('/api/v1/products/', data),
  updateProduct: (id, data) => api.put(`/api/v1/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/api/v1/products/${id}`),
  
  getCarouselImages: () => api.get('/api/v1/banners/'),
  createCarouselImage: (data) => api.post('/api/v1/banners/', data),
  updateCarouselImage: (id, data) => api.put(`/api/v1/banners/${id}`, data),
  deleteCarouselImage: (id) => api.delete(`/api/v1/banners/${id}`),
  
  getCart: () => api.get('/api/v1/cart'),
  addToCart: (productId, quantity) => api.post('/api/v1/cart/add', { product_id: productId, quantity }),
  updateCartItem: (itemId, quantity) => api.put(`/api/v1/cart/${itemId}`, { quantity }),
  removeFromCart: (itemId) => api.delete(`/api/v1/cart/${itemId}`),
};
